import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(private afdatabase: AngularFireDatabase) { }
  createRequest(request) {
    const cleanEmail  = request.email.replace(/\./g, ',');
    return this.afdatabase.object('request/' + cleanEmail + '/' + request.product.pid).set(request);
  }
  setRequestStatus(request, status) {
    const cleanEmail  = request.email.replace(/\./g, ',');
    return this.afdatabase.object('request/' + cleanEmail + '/' + request.product.pid + '/status').set(status);
  }
  setExpirationDate(request, exp) {
    const cleanEmail  = request.email.replace(/\./g, ',');
    return this.afdatabase.object('request/' + cleanEmail + '/' + request.product.pid + '/product/date_expiration').set(exp);
  }
  setRequestHistory(request, history) {
    const cleanEmail  = request.email.replace(/\./g, ',');
    return this.afdatabase.object('request/' + cleanEmail + '/' + request.product.pid + '/history/' + history.hid).set(history);
  }
  getRequests() {
    return this.afdatabase.list('request/');
  }
  getRequestsForEmail(email) {
    const cleanEmail  = email.replace(/\./g, ',');
    return this.afdatabase.list('request/' + cleanEmail);
  }
  getRequestsForEmailAndId(email, id) {
    const cleanEmail  = email.replace(/\./g, ',');
    return this.afdatabase.object('request/' + cleanEmail + '/' + id);
  }
  getRequestsForStatus(email, status){
    const cleanEmail  = email.replace(/\./g, ',');
    return this.afdatabase.list('request/' + cleanEmail, ref => ref.orderByChild('status').equalTo(status));
  }
}
